var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "el-popover",
        {
          ref: "treePopover",
          attrs: {
            placement: "bottom-start",
            trigger: "manual",
            "popper-class": "popover",
          },
          model: {
            value: _vm.showPopover,
            callback: function ($$v) {
              _vm.showPopover = $$v
            },
            expression: "showPopover",
          },
        },
        [
          _c(
            "div",
            { staticClass: "tree-box" },
            [
              _c(
                "div",
                { staticClass: "input" },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      "prefix-icon": "el-icon-search",
                      placeholder: "请输入人员搜索",
                    },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-tree", {
                ref: "tree",
                attrs: {
                  "highlight-current": "",
                  props: _vm.props,
                  data: _vm.treeData,
                  "show-checkbox": !_vm.onlyOne,
                  "default-checked-keys": _vm.selectIds,
                  "filter-node-method": _vm.filterNode,
                  "node-key": "id",
                },
                on: { check: _vm.depCheck, "node-click": _vm.checkUser },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c("span", { staticClass: "custom-tree-node" }, [
                        _c(
                          "span",
                          {
                            class: {
                              isChecked: _vm.userIds.includes(data.value),
                            },
                          },
                          [
                            data.type == 0
                              ? _c("i", {
                                  staticClass:
                                    "tree-icon iconfont iconwenjianjia",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            data.type == 1
                              ? _c("img", {
                                  staticClass: "avatar",
                                  attrs: { src: data.avatar, alt: "" },
                                })
                              : _vm._e(),
                            _vm._v("\n            " + _vm._s(node.label)),
                          ]
                        ),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "reference" },
            [
              _vm._t("custom"),
              _vm._v(" "),
              !_vm.isSlots
                ? _c(
                    "div",
                    {
                      ref: "select",
                      staticClass: "select plan-footer-one mr10",
                      on: { click: _vm.handlePopoverShow },
                    },
                    [
                      _vm.userList && _vm.userList.length == 0
                        ? _c("span", { staticClass: "placeholder" }, [
                            _vm._v(_vm._s(_vm.placeholder)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userList.length > 0 && !_vm.isSearch
                        ? _c(
                            "div",
                            { staticClass: "flex-box" },
                            _vm._l(_vm.userList, function (item, index) {
                              return _c(
                                "span",
                                {
                                  key: index,
                                  staticClass:
                                    "el-tag el-tag--small el-tag--info el-tag--light mr10",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _vm.isAvatar
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        attrs: { src: item.avatar, alt: "" },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    " " + _vm._s(item.name) + "\n            "
                                  ),
                                  _c("i", {
                                    staticClass: "el-tag__close el-icon-close",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.cardTag(index)
                                      },
                                    },
                                  }),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userList.length > 0 && _vm.isSearch
                        ? _c(
                            "div",
                            { staticClass: "flex-box" },
                            [
                              _vm._l(
                                _vm.userList.slice(0, 1),
                                function (item, index) {
                                  return _c(
                                    "span",
                                    {
                                      key: index,
                                      staticClass:
                                        "el-tag el-tag--small el-tag--info el-tag--light mr10",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _vm.isAvatar
                                        ? _c("img", {
                                            staticClass: "avatar",
                                            attrs: {
                                              src: item.avatar,
                                              alt: "",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        " " +
                                          _vm._s(item.name) +
                                          "\n            "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-tag__close el-icon-close",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.cardTag(0)
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.userList.length > 1
                                ? _c(
                                    "el-tag",
                                    {
                                      staticClass:
                                        "el-tag el-tag--small el-tag--info el-tag--light",
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.userList.length - 1)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }